import { render, staticRenderFns } from "./LogChart.vue?vue&type=template&id=3b5d0a58&scoped=true&"
import script from "./LogChart.vue?vue&type=script&lang=js&"
export * from "./LogChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5d0a58",
  null
  
)

export default component.exports